import { includes, without, append } from 'ramda';

import { EPreciseFilterNames, EPreciseFilterValues, TPreciseFiltersState } from '../../../types/redux/preciseFilters';

export const handleCheckboxChange = (
  filterValue: EPreciseFilterValues,
  preciseFiltersState: TPreciseFiltersState,
  filterName: EPreciseFilterNames,
): TPreciseFiltersState => {
  const filterPrevState = preciseFiltersState[filterName] || [];

  const filterNextState = includes(filterValue, filterPrevState)
    ? without([filterValue], filterPrevState)
    : append(filterValue, filterPrevState);

  return { ...preciseFiltersState, [filterName]: filterNextState };
};
